import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import axios from "axios";
import {defaultVariabls} from "../../../../../config/index";
import {connect} from "trim-redux";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import {Translate} from "../../../../../config/Translate";
import withWidth from "@material-ui/core/withWidth/withWidth";
import DeleteButton from "../../../../components/elements/DeleteButton";
import MakeBannerButton from "./Make‌BannerButton";

class SlideShowItem extends React.Component {

    render(){
        let {item} = this.props;
        return (
            <div
                className="slide_show_item banner_item"
            >
                <p>{Translate[item.position]}</p>
                <img src={`${defaultVariabls.uploads}/FileManager/${item.thumbnail.name}.${item.thumbnail.extension}`}/>
                <div className="controller">
                    <MakeBannerButton id={item.id} reload={() => this.props.reload()}/>

                </div>
            </div>
        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(SlideShowItem)))));